import axios from "axios";

// Converts from degrees to radians.
function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

// Converts from radians to degrees.
function toDegrees(radians) {
  return (radians * 180) / Math.PI;
}

function getHeading(startLat:number, startLng:number, destLat:number, destLng:number) {
  var startLat = toRadians(startLat);
  var startLng = toRadians(startLng);
  var destLat = toRadians(destLat);
  var destLng = toRadians(destLng);

  var y = Math.sin(destLng - startLng) * Math.cos(destLat);
  var x =
    Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  var brng = Math.atan2(y, x);
  var brng = toDegrees(brng);
  return (brng + 360) % 360;
}

const StreetView = async ({ x, y, key }) => {
  console.log("STREET VIEW", { x, y, key });

  // get session key
  var session = await axios.post(
    `https://tile.googleapis.com/v1/createSession?key=${key}`,
    {
      mapType: "streetview",
      language: "en-US",
      region: "US",
    }
  );

  // find nearest panoramic
  var res = await axios.get(
    `https://tile.googleapis.com/v1/streetview/metadata?lat=${y}&lng=${x}&radius=200&session=${session.data.session}&key=${key}`,
    // { validateStatus: false }
  );

  if (res.data.panoId) {
    // Calculate heading
    var b = getHeading(res.data.lat, res.data.lng, y, x);

    return `https://www.google.com/maps/@?api=1&map_action=pano&pano=${
      res.data.panoId
    }&heading=${b.toFixed(0)}&fov=90&pitch=0`;
  } else {
    return null;
  }
};

export default StreetView;
